module.exports = __webpack_public_path__ + "static/aerial-views-xi-7324eb2424d9cb80131505fe6570dff3.jpg";